import React from 'react'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import { createStatusChip } from 'components/status-chip'
import { useRequirementChipStyles } from './styles'

const TONES = {
  success: { backgroundColor: '#BEF1BB', color: '#00210B' },
  danger: { backgroundColor: '#FFBCBC', color: '#410002' },
  warning: { backgroundColor: '#FFE0B2', color: '#C77700' },
  info: { backgroundColor: '#E0EAFF', color: '#001C57' },
  neutral: { backgroundColor: '#EBF0F2', color: '#172024' },
}

export const statuses = {
  NOT_STARTED: 'NOT_STARTED',
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  CANCELLED: 'CANCELLED',
  FLAGGED: 'FLAGGED',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  CHECKING: 'CHECKING',
  ERROR: 'ERROR',
  NOT_SETUP: 'NOT_SETUP',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
  DUPLICATE: 'DUPLICATE',
  INCOMPLETE: 'INCOMPLETE',
  EXPIRED: 'EXPIRED',
  NEAR_EXPIRY: 'NEAR_EXPIRY',
}

const statusMap = {
  [statuses.NOT_STARTED]: { label: 'Not Started', tone: 'info' },
  [statuses.SUBMITTED]: { label: 'Request Sent', tone: 'info' },
  [statuses.PENDING]: { label: 'Pending', tone: 'warning' },
  [statuses.PENDING_VERIFICATION]: {
    label: 'Pending Verification',
    tone: 'warning',
  },
  [statuses.CANCELLED]: { label: 'Cancelled', tone: 'neutral' },
  [statuses.FLAGGED]: { label: 'Flagged', tone: 'warning' },
  [statuses.PASSED]: { label: 'Passed', tone: 'success' },
  [statuses.FAILED]: { label: 'Failed', tone: 'danger' },
  [statuses.CHECKING]: { label: 'Checking...', tone: 'info' },
  [statuses.ERROR]: { label: 'ERROR', tone: 'danger' },
  [statuses.NOT_SETUP]: { label: 'Not Setup', tone: 'info' },
  [statuses.ACTIVE]: { label: 'Active', tone: 'success' },
  [statuses.CLOSED]: { label: 'Closed', tone: 'neutral' },
  [statuses.DUPLICATE]: { label: 'Duplicate', tone: 'neutral' },
  [statuses.INCOMPLETE]: { label: 'Incomplete', tone: 'info' },
  [statuses.EXPIRED]: { label: 'Expired', tone: 'danger' },
  [statuses.NEAR_EXPIRY]: { label: 'Near Expiry', tone: 'warning' },
}

const muiStatusMap = {
  [statuses.NOT_STARTED]: { label: 'Not Started', color: 'gray' },
  [statuses.SUBMITTED]: { label: 'Request Sent', color: 'info' },
  [statuses.PENDING]: { label: 'Pending', color: 'gray' },
  [statuses.PENDING_VERIFICATION]: {
    label: 'Pending Verification',
    color: 'gray',
  },
  [statuses.CANCELLED]: { label: 'Cancelled', color: 'gray' },
  [statuses.FLAGGED]: { label: 'Flagged', color: 'gray' },
  [statuses.PASSED]: { label: 'Passed', color: 'success' },
  [statuses.FAILED]: { label: 'Failed', color: 'gray' },
  [statuses.CHECKING]: { label: 'Checking...', color: 'gray' },
  [statuses.ERROR]: { label: 'ERROR', color: 'gray' },
  [statuses.NOT_SETUP]: { label: 'Not Setup', color: 'gray' },
  [statuses.ACTIVE]: { label: 'Active', color: 'success' },
  [statuses.CLOSED]: { label: 'Closed', color: 'gray' },
  [statuses.DUPLICATE]: { label: 'Duplicate', color: 'gray' },
  [statuses.INCOMPLETE]: { label: 'Incomplete', color: 'gray' },
  [statuses.EXPIRED]: { label: 'Expired', color: 'danger' },
  [statuses.NEAR_EXPIRY]: { label: 'Near Expiry', color: 'warning' },
}

export const MuiRequirementStatusChip = createStatusChip(muiStatusMap)

export default function StatusChip({
  status,
  labelPrefix,
  labelSuffix,
  labelOverride,
  className,
}) {
  const classes = useRequirementChipStyles()
  const chipInfo = statusMap[status]
  const tone = TONES[chipInfo.tone]
  const baseLabel = labelOverride != null ? labelOverride : chipInfo.label
  const label = `${labelPrefix || ''}${baseLabel}${labelSuffix || ''}`

  return (
    <Box
      component="span"
      className={clsx(classes.chip, className)}
      style={{
        backgroundColor: tone.backgroundColor,
        color: tone.color,
      }}
    >
      {label}
    </Box>
  )
}
